/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { UserProcessDto } from '../models';
// @ts-ignore
import type { UserProcessInfoDto } from '../models';
/**
 * RestUserProcessApi - axios parameter creator
 * @export
 */
export const RestUserProcessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get quiz identifiers
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProcess: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserProcess', 'userId', userId)
            const localVarPath = `/api/users/{userId}/process`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get quiz identifiers
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProcessInfo: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserProcessInfo', 'userId', userId)
            const localVarPath = `/api/users/{userId}/process-info`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestUserProcessApi - functional programming interface
 * @export
 */
export const RestUserProcessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestUserProcessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get quiz identifiers
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserProcess(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProcessDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserProcess(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUserProcessApi.getUserProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get quiz identifiers
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserProcessInfo(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProcessInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserProcessInfo(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUserProcessApi.getUserProcessInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestUserProcessApi - factory interface
 * @export
 */
export const RestUserProcessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestUserProcessApiFp(configuration)
    return {
        /**
         * 
         * @summary get quiz identifiers
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProcess(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserProcessDto> {
            return localVarFp.getUserProcess(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get quiz identifiers
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProcessInfo(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserProcessInfoDto> {
            return localVarFp.getUserProcessInfo(userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestUserProcessApi - interface
 * @export
 * @interface RestUserProcessApi
 */
export interface RestUserProcessApiInterface {
    /**
     * 
     * @summary get quiz identifiers
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserProcessApiInterface
     */
    getUserProcess(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserProcessDto>;

    /**
     * 
     * @summary get quiz identifiers
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserProcessApiInterface
     */
    getUserProcessInfo(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserProcessInfoDto>;

}

/**
 * RestUserProcessApi - object-oriented interface
 * @export
 * @class RestUserProcessApi
 * @extends {BaseAPI}
 */
export class RestUserProcessApi extends BaseAPI implements RestUserProcessApiInterface {
    /**
     * 
     * @summary get quiz identifiers
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserProcessApi
     */
    public getUserProcess(userId: string, options?: RawAxiosRequestConfig) {
        return RestUserProcessApiFp(this.configuration).getUserProcess(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get quiz identifiers
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUserProcessApi
     */
    public getUserProcessInfo(userId: string, options?: RawAxiosRequestConfig) {
        return RestUserProcessApiFp(this.configuration).getUserProcessInfo(userId, options).then((request) => request(this.axios, this.basePath));
    }
}

